<template>
    <div id="VisibilityWorkFlow">
        <VisibilityChanger v-model="form.visibility" :alertMessage="false" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VisibilityChanger from "../../views/Pages/WhatsappV1/VisibilityChanger.vue";

export default {
    name: "VisibilityWorkFlow",
    props: {
        details: {
            type: Object,
        },
    },
    components: {
        VisibilityChanger,
    },
    data() {
        return {
            form: {
                visibility: this.details?.visibility || {},
            },
        };
    },
    computed: {
        ...mapState({
            workflows: (state) => state.tasks.workflows,
        }),
    },
    methods: {
        ...mapActions({
            getWorkFlows: "tasks/getWorkFlows",
            updateWorkflow: "tasks/updateWorkflow",
        }),
    },
    mounted() {
        this.getWorkFlows().then(() => {
            const workflow = this.workflows.find((workflow) => workflow._id === this.details.workflowId);
            if (workflow) {
                this.form = { ...workflow };
            } else {
                this.form = { visibility: {} };
            }
        });
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit("update-form", this.form);
            },
        },
    },
};
</script>
